import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
import { useState } from "react";
import { createPaymentIntent } from "../../../../../services/paymentService";
import { createBooking } from "../../../../../services/bookingService";
import { Link } from "react-router-dom";
import Invoice from "../../../../../Pages/User/invoice";

const styles = {
  page: {
    minHeight: "50vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f9fafb", // gray-50
  },
  form: {
    width: "100%",
    maxWidth: "420px",
    padding: "24px",
    background: "#ffffff",
    borderRadius: "12px",
    boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
  },
  title: {
    marginBottom: "16px",
    fontSize: "20px",
    fontWeight: "600",
    color: "#111827", // gray-900
  },
  cardWrapper: {
    padding: "12px",
    border: "1px solid #d1d5db", // gray-300
    borderRadius: "8px",
    marginBottom: "16px",
  },
  button: {
    width: "100%",
    padding: "12px",
    background: "#2563eb", // blue-600
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
  },
  error: {
    color: "#dc2626",
    marginBottom: "12px",
    fontSize: "14px",
  },
  success: {
    color: "#16a34a",
    marginBottom: "12px",
    fontSize: "14px",
  },
};

const cardStyle = {
  style: {
    base: {
      color: "#1f2937", // gray-800
      fontSize: "16px",
      fontFamily: "Inter, system-ui, sans-serif",
      fontSmoothing: "antialiased",
      "::placeholder": {
        color: "#9ca3af", // gray-400
      },
    },
    invalid: {
      color: "#dc2626", // red-600
    },
  },
};


export default function CheckoutForm({ bookingData }) {
  const stripe = useStripe();
  const elements = useElements();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [booking, setBooking] = useState();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) return;

    setLoading(true);
    setError(null);

    // 1. Ask backend to create PaymentIntent
    createPaymentIntent(bookingData.totalPrice / 2).then(async (res) => {
      const { clientSecret } = res;

      // 2. Confirm payment
      const result = await stripe.confirmCardPayment(clientSecret, {
        payment_method: {
          card: elements.getElement(CardElement),
        },
      });

      if (result.error) {
        setError(result.error.message);
      } else {
        if (result.paymentIntent.status === "succeeded") {
          setSuccess(true);
          createBooking(bookingData).then((res) => {
            setBooking(res);
          });
        }
      }
    })

    setLoading(false);
  };

  return (
    <div style={styles.page}>
      {success ? (
        <div style={styles.form}>
          <h2 style={styles.title}>Successful!</h2>
          <p>The Payment was successful and The Tour has been booked.</p>
          <p>You can download the invoice here! <Invoice bookingId={booking.id} /> </p>
          <p>You can see your bookings here! <Link to={'/my-bookings'}>My Bookings</Link> </p>
        </div>
      ) : (
        <div style={styles.form}>
          <h2 style={styles.title}>Amount: ${bookingData.totalPrice}</h2>
          <p>You have to make an advance payment of 50% of the total amount.</p>
          <div style={styles.cardWrapper}>
            <CardElement options={cardStyle} />
          </div>

          {error && <p style={styles.error}>{error}</p>}

          <button
            disabled={!stripe || loading}
            style={{
              ...styles.button,
              opacity: loading ? 0.7 : 1,
            }}
            onClick={handleSubmit}
          >
            {loading ? "Processing…" : `Pay $${bookingData.totalPrice / 2}`}
          </button>
        </div>
      )}
    </div>
  );
}
